import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout = ({ children, defaultSidebarOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultSidebarOpen);

// const Layout = ({ children, defaultSidebarOpen = true }) => {
//   const [isOpen, setIsOpen] = useState(defaultSidebarOpen);

  useEffect(() => {
    setIsOpen(defaultSidebarOpen);
  }, [defaultSidebarOpen]);

  const [sidebarWidth, setSidebarWidth] =
    useState(270);

  const [isDragging, setIsDragging] =
    useState(false);


    

  /* NAVBAR HEIGHT */
  const navbarHeight = 72;

  /* SIDEBAR RESIZE */
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;

      let newWidth = e.clientX;

      if (newWidth < 220) newWidth = 220;

      if (newWidth > 500) newWidth = 500;

      setSidebarWidth(newWidth);
    };

    const handleMouseUp = () => {
      if (isDragging) {
        setIsDragging(false);

        document.body.style.cursor =
          "default";
      }
    };

    document.addEventListener(
      "mousemove",
      handleMouseMove
    );

    document.addEventListener(
      "mouseup",
      handleMouseUp
    );

    return () => {
      document.removeEventListener(
        "mousemove",
        handleMouseMove
      );

      document.removeEventListener(
        "mouseup",
        handleMouseUp
      );
    };
  }, [isDragging]);

  const handleMouseDown = (e) => {
    e.preventDefault();

    setIsDragging(true);

    document.body.style.cursor =
      "col-resize";
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const currentWidth = isOpen
    ? sidebarWidth
    : 0;

  return (
    <div
      style={{
        background: "#f5f7fb",
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* NAVBAR */}
      <Navbar
        toggleSidebar={toggleSidebar}
      />

      {/* SIDEBAR */}
      <Sidebar
        isOpen={isOpen}
        width={sidebarWidth}
        isDragging={isDragging}
        handleMouseDown={handleMouseDown}
      />

      {/* MAIN CONTENT */}
      <div
        style={{
          marginLeft: `${currentWidth}px`,

          marginTop: `${navbarHeight}px`,

          width: `calc(100% - ${currentWidth}px)`,

          minHeight: `calc(100vh - ${navbarHeight}px)`,

          padding: "22px",

          transition: isDragging
            ? "none"
            : "margin-left 0.3s ease, width 0.3s ease",

          overflowX: "auto",
        }}
      >
        {/* PAGE CONTENT */}
        <div
          style={{
            background: "#ffffff",

            borderRadius: "18px",

            padding: "22px",

            minHeight: "100%",

            boxShadow:
              "0 2px 12px rgba(0,0,0,0.04)",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  defaultSidebarOpen: PropTypes.bool,
};

export default Layout;